<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menu"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <v-text-field
      :name="name"
      slot="activator"
      :value="
        date
          ? $moment(date).format('LL')
          : value
          ? $moment(value).format('LL')
          : null
      "
      :label="label"
      v-validate="required ? 'required' : ''"
      :data-vv-as="label"
      :error-messages="errors.collect(apiName)"
      readonly
    ></v-text-field>
    <v-date-picker
      v-model="date"
      @input="menu = false"
      :locale="LANG"
      reactive
      :max="maxToday ? $moment().format('YYYY-MM-DD') : null"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    name: String,
    value: String,
    label: String,
    apiName: String,
    required: {
      type: Boolean,
      default: false
    },
    maxToday: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      LANG: process.env.VUE_APP_LANG,
      menu: false,
      date: this.value
    };
  },
  watch: {
    date: function() {
      this.$emit("input", this.date);
    }
  }
};
</script>
